import * as styles from "./WindowTabs.css";

import { clsx } from "clsx";
import type { JSX } from "react";

import { Icon } from "@frontend/components/atoms/Icon";

import type { WindowTabProps, WindowTabsProps } from "./Window.types";

export function WindowTabs({
  className,
  ...props
}: WindowTabsProps): JSX.Element {
  return (
    <div
      data-slot="window-tabs"
      role="tablist"
      className={clsx(styles.tabs, className)}
      {...props}
    />
  );
}

export function WindowTab({
  active = false,
  onSelect,
  onClose,
  closeLabel = "Close",
  className,
  children,
  ...props
}: WindowTabProps): JSX.Element {
  return (
    <div
      data-slot="window-tab"
      data-status={active ? "active" : undefined}
      className={clsx(styles.tab, className)}
      {...props}
    >
      <button
        type="button"
        role="tab"
        aria-selected={active}
        className={styles.label}
        onClick={onSelect}
      >
        {children}
      </button>
      {onClose && (
        <button
          type="button"
          className={styles.close}
          aria-label={closeLabel}
          onClick={onClose}
        >
          <Icon name="X" size="sm" />
        </button>
      )}
    </div>
  );
}
